import { Box, InputError, Spinner } from '@foodsby/nutrient'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

import { SimpleSpinner } from '../common/SimpleSpinner'
import Action from '../common/Action'
import FriendLabel from './FriendLabel'

export const SuggestedFriend = ({
  addFriendStart,
  addedFriends,
  friend,
  isAddingAFriend,
  isLoadingFriends,
  isWebpSupported,
  setAddedFriends,
  setIsAddingAFriend,
  setSuggestedFriendsList,
  suggestedFriendsList,
}) => {
  const [isAdding, setIsAdding] = useState(false)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (isAdding && !isLoadingFriends) {
      setSuccess(true)
      setIsAddingAFriend(false)
    }
  }, [isAdding, isLoadingFriends, setIsAddingAFriend])

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuggestedFriendsList(suggestedFriendsList.filter(user => friend.userId !== user.userId))
        setAddedFriends(addedFriends.concat(friend.userId))
      }, 750)
    }
  }, [
    addedFriends,
    friend.userId,
    setAddedFriends,
    setSuggestedFriendsList,
    success,
    suggestedFriendsList,
  ])

  return (
    <div className="suggested-friend col-xs-6 col-sm-4">
      <div className="suggested-friend-name">
        <FriendLabel
          avatarId={friend.avatarId}
          email={friend.email}
          firstName={friend.firstName}
          isWebpSupported={isWebpSupported}
          lastName={friend.lastName}
          size="large"
        />
        {success ? (
          <i className="icon-check-circle successIcon" />
        ) : isAdding ? (
          <Spinner className="spinner-xs secondary" />
        ) : (
          <Action
            className="add-friend-btn secondary"
            disabled={isLoadingFriends || isAdding || isAddingAFriend}
            onClick={() => {
              setIsAddingAFriend(true)
              setIsAdding(true)
              addFriendStart(friend.userId)
            }}
          >
            + Connect
          </Action>
        )}
      </div>
    </div>
  )
}

export const SuggestedFriends = ({
  addFriendStart,
  suggestedFriends = [],
  isLoadingFriends,
  getSuggestedFriendsStart,
  isWebpSupported,
}) => {
  const [suggestedFriendsList, setSuggestedFriendsList] = useState([])
  const [isAddingAFriend, setIsAddingAFriend] = useState(false)
  const [addedFriends, setAddedFriends] = useState([])

  useEffect(() => {
    setSuggestedFriendsList(suggestedFriends.slice(0, 3))
  }, [suggestedFriends])

  useEffect(() => {
    setTimeout(() => {
      setSuggestedFriendsList(
        suggestedFriends.filter(s => !addedFriends.includes(s.userId)).slice(0, 3),
      )
    }, 300)
  }, [addedFriends, suggestedFriends])

  return (
    <div className="row suggested-friends-container">
      {suggestedFriendsList && suggestedFriendsList.length > 0 && (
        <div className="col-xs-12">
          <hr className="myfriends-divider" />
          <h4>People you might know</h4>
          <CSSTransitionGroup
            className="row start-xs suggested-friends"
            transitionEnter={false}
            transitionLeaveTimeout={0}
            transitionName="move"
          >
            {suggestedFriendsList &&
              suggestedFriendsList.map(s => (
                <SuggestedFriend
                  addedFriends={addedFriends}
                  addFriendStart={addFriendStart}
                  friend={s}
                  getSuggestedFriendsStart={getSuggestedFriendsStart}
                  isAddingAFriend={isAddingAFriend}
                  isLoadingFriends={isLoadingFriends}
                  isWebpSupported={isWebpSupported}
                  key={s.userId}
                  setAddedFriends={setAddedFriends}
                  setIsAddingAFriend={setIsAddingAFriend}
                  setSuggestedFriendsList={setSuggestedFriendsList}
                  suggestedFriendsList={suggestedFriendsList}
                />
              ))}
          </CSSTransitionGroup>
        </div>
      )}
    </div>
  )
}

export const NewFriendAvatar = () => {
  return (
    <div className="new-friend-avatar">
      <img alt="" src="https://images.foodsby.com/conweb/friend-avatar-empty.png" width="80px" />
      <div>New friend!</div>
    </div>
  )
}

export const MyFriendsTitle = ({ friends }) => {
  return (
    <>
      <div className="my-friends-title">
        <div className="col-xs-12">
          {friends.length < 6 ? (
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              justifyContent="space-around"
            >
              <img
                alt=""
                src="https://images.foodsby.com/www/theme/connect-friends.png"
                style={{ marginBottom: '8px' }}
                width="60px"
              />
              <h4>Friends who accept your invite will appear here</h4>
            </Box>
          ) : (
            <h4 className="row">Your Friends</h4>
          )}
        </div>
      </div>
    </>
  )
}

export const MyFriendAvatar = ({ deleteCurrentFriend, friend, isWebpSupported }) => {
  const [removingFriend, setRemovingFriend] = useState(false)
  return (
    <div
      className={cn({
        'col-xs-6 col-sm-4': true,
        'removing-friend': removingFriend,
      })}
    >
      <FriendLabel
        avatarId={friend.avatarId}
        classNames="roboto"
        email={friend.email}
        firstName={friend.firstName}
        isWebpSupported={isWebpSupported}
        lastName={friend.lastName}
        showName={friend.firstName}
        showOnlyFirstName
        size="large"
      />
      <Action
        className="friend-remove"
        onClick={() => {
          setRemovingFriend(true)
          deleteCurrentFriend(friend.connectionId)
        }}
      >
        <img alt="" src="https://images.foodsby.com/conweb/cancel-icon.svg" width="20px" />
      </Action>
      {removingFriend && <Spinner className="spinner-xs primary" />}
    </div>
  )
}

export const ReceivedFriendship = ({ cancelOutgoingFriendRequest, isWebpSupported, request }) => {
  const [responding, setResponding] = useState(false)
  return (
    <div className="row friend-request-row">
      <div className="col-xs-8 start-xs friend-request">
        <FriendLabel
          avatarId={request.avatarId}
          email={request.email}
          firstName={request.firstName}
          isWebpSupported={isWebpSupported}
          lastName={request.lastName}
          showEmail={false}
          size="medium"
        />
      </div>
      <div className="col-xs-4 end-xs invites-sent">
        {request.firstName && request.lastName ? 'Request Sent' : 'Invite Sent'}

        <Action
          className="cancel-invite"
          disabled={responding}
          onClick={() => {
            setResponding(true)
            cancelOutgoingFriendRequest(request.connectionId)
          }}
        >
          {responding ? (
            <Spinner className="spinner-xs primary" />
          ) : (
            <img alt="" src="https://images.foodsby.com/conweb/cancel-icon.svg" width="20px" />
          )}
        </Action>
      </div>
    </div>
  )
}

export const InvitedFriendship = ({ friendRequestResponse, isWebpSupported, request }) => {
  const [responding, setResponding] = useState(false)
  return (
    <div className="row friend-request-row">
      <div className="col-xs-8 start-xs friend-request">
        <FriendLabel
          avatarId={request.avatarId}
          email={request.email}
          firstName={request.firstName}
          isWebpSupported={isWebpSupported}
          lastName={request.lastName}
          size="medium"
        />
      </div>
      <div className="col-xs-4 end-xs invites-sent">
        {responding ? (
          <Spinner className="spinner-xs primary" />
        ) : (
          <>
            <Action
              disabled={responding}
              notification={true}
              onClick={() => {
                setResponding(true)
                friendRequestResponse({
                  action: 'ACCEPT',
                  requestId: request.connectionId,
                })
              }}
            >
              Accept
            </Action>
            <span className="friendLink">|</span>
            <Action
              disabled={responding}
              onClick={() => {
                setResponding(true)
                friendRequestResponse({
                  action: 'DECLINE',
                  requestId: request.connectionId,
                })
              }}
            >
              Decline
            </Action>
          </>
        )}
      </div>
    </div>
  )
}

export const FriendInvites = ({
  cancelOutgoingFriendRequest,
  cancelOutgoingRequestError,
  friendRequestLoadingError,
  friendRequestResponse,
  friendRequestResponseError,
  incomingFriendRequests,
  isWebpSupported,
  outgoingFriendRequests,
}) => {
  return (
    <div className="friend-invites">
      {incomingFriendRequests && incomingFriendRequests.length > 0 && (
        <>
          <hr className="myfriends-divider" />
          <h4 className="friend-invites-title">Received</h4>
        </>
      )}
      {incomingFriendRequests &&
        incomingFriendRequests.map(request => (
          <InvitedFriendship
            friendRequestResponse={friendRequestResponse}
            isWebpSupported={isWebpSupported}
            key={request.connectionId}
            request={request}
          />
        ))}
      {outgoingFriendRequests && outgoingFriendRequests.length > 0 && (
        <>
          <hr className="myfriends-divider" />
          <h4 className="friend-invites-title">Invited</h4>
        </>
      )}
      {outgoingFriendRequests &&
        outgoingFriendRequests.map(request => (
          <ReceivedFriendship
            cancelOutgoingFriendRequest={cancelOutgoingFriendRequest}
            isWebpSupported={isWebpSupported}
            key={request.connectionId}
            request={request}
          />
        ))}
      {(friendRequestLoadingError || friendRequestResponseError || cancelOutgoingRequestError) && (
        <div className="row center-xs">
          <InputError
            isOpened={
              (friendRequestLoadingError && friendRequestLoadingError !== null) ||
              (cancelOutgoingRequestError && cancelOutgoingRequestError !== null)
            }
          >
            {friendRequestLoadingError || friendRequestResponseError || cancelOutgoingRequestError}
          </InputError>
        </div>
      )}
    </div>
  )
}

export const MyFriendsAvatars = ({
  deleteCurrentFriend,
  deletingFriendError,
  friends,
  isWebpSupported,
  loadFriendsError,
}) => {
  const MIN_FRIEND_AVATARS = 6
  const MAX_FRIEND_AVATARS = 6
  const NUM_EXTRA_AVATARS = friends.length < 6 ? 6 - friends.length : 0
  const [numFriendsVisible, setNumFriendsVisible] = useState(MAX_FRIEND_AVATARS)
  const [toggleShowMore, setToggleShowMore] = useState(false)

  return (
    <>
      <div className="row my-friends-avatars">
        {friends.slice(0, numFriendsVisible).map(friend => {
          return (
            <MyFriendAvatar
              deleteCurrentFriend={deleteCurrentFriend}
              friend={friend}
              isWebpSupported={isWebpSupported}
              key={friend.userId}
            />
          )
        })}
        {friends.length < MIN_FRIEND_AVATARS &&
          Array.from({ length: NUM_EXTRA_AVATARS }, (val, i) => (
            <div className="col-xs-6 col-sm-4" key={i}>
              <NewFriendAvatar />
            </div>
          ))}
      </div>
      <div className="row center-xs">
        <div className="col-xs-12">
          {friends.length > 6 && !toggleShowMore ? (
            <Action
              onClick={() => {
                setNumFriendsVisible(friends.length)
                setToggleShowMore(!toggleShowMore)
              }}
            >
              Show All Friends ({friends.length})
            </Action>
          ) : (
            friends.length > 6 && (
              <Action
                onClick={() => {
                  setNumFriendsVisible(MAX_FRIEND_AVATARS)
                  setToggleShowMore(!toggleShowMore)
                }}
              >
                Show Less
              </Action>
            )
          )}
        </div>
      </div>
      {(deletingFriendError || loadFriendsError) && (
        <div className="row center-xs">
          <InputError>{loadFriendsError || deletingFriendError}</InputError>
        </div>
      )}
    </>
  )
}

export const MyFriends = ({
  cancelOutgoingFriendRequest,
  cancelOutgoingRequestError,
  deleteCurrentFriend,
  deletingFriendError,
  friendRequestLoadingError,
  friendRequestResponse,
  friendRequestResponseError,
  friends = [],
  incomingFriendRequests,
  isCancelingOutgoingRequest,
  isLoadingFriendRequests = true,
  isLoadingSuggestedFriends = true,
  isLoadingFriends = true,
  isRespondingToFriendRequest,
  outgoingFriendRequests,
  loadFriendsError,
  suggestedFriends = [],
  addFriendStart,
  getSuggestedFriendsStart,
  isWebpSupported,
}) => {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    if (!loaded && !isLoadingFriends && !isLoadingFriendRequests && !isLoadingSuggestedFriends) {
      setLoaded(true)
    }
  }, [isLoadingFriends, isLoadingFriendRequests, isLoadingSuggestedFriends, loaded])

  return !loaded || isLoadingSuggestedFriends ? (
    <SimpleSpinner />
  ) : (
    <>
      <MyFriendsTitle friends={friends} isLoadingFriends={isLoadingFriends} />
      <MyFriendsAvatars
        deleteCurrentFriend={deleteCurrentFriend}
        deletingFriendError={deletingFriendError}
        friends={friends}
        isWebpSupported={isWebpSupported}
        loadFriendsError={loadFriendsError}
      />
      {suggestedFriends && suggestedFriends.length > 0 && (
        <SuggestedFriends
          addFriendStart={addFriendStart}
          getSuggestedFriendsStart={getSuggestedFriendsStart}
          isLoadingFriends={isLoadingFriends}
          isWebpSupported={isWebpSupported}
          suggestedFriends={suggestedFriends}
        />
      )}
      {((outgoingFriendRequests && outgoingFriendRequests.length > 0) ||
        (incomingFriendRequests && incomingFriendRequests.length > 0)) && (
        <>
          <FriendInvites
            cancelOutgoingFriendRequest={cancelOutgoingFriendRequest}
            cancelOutgoingRequestError={cancelOutgoingRequestError}
            friendRequestLoadingError={friendRequestLoadingError}
            friendRequestResponse={friendRequestResponse}
            friendRequestResponseError={friendRequestResponseError}
            incomingFriendRequests={incomingFriendRequests}
            isCancelingOutgoingRequest={isCancelingOutgoingRequest}
            isRespondingToFriendRequest={isRespondingToFriendRequest}
            isWebpSupported={isWebpSupported}
            outgoingFriendRequests={outgoingFriendRequests}
          />
        </>
      )}
    </>
  )
}

export default MyFriends
